<template>
  <v-card id="wdg2">
    <v-form ref="form" v-model="valid">
      <v-card-title>
        <span class="headline">{{ $t("signin.titleWdg2") }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-text-field
            id="e-mail-wdg2"
            v-model="logInUser.email"
            :label="$t('signin.email')"
            :rules="emptyField"
            required
            color="grey"
          ></v-text-field>
          <v-text-field
            id="password-wdg2"
            v-model="logInUser.password"
            :label="$t('signin.password')"
            :rules="emptyField"
            type="password"
            color="grey"
            required
          ></v-text-field>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">
          {{ $t("crudLocation.cancel") }}
        </v-btn>
        <v-btn
          id="button-login-wdg2"
          color="red darken-1"
          text
          @click="loginWdg2"
          :disabled="!valid"
        >
          {{ $t("signin.title") }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import LogInUser from "@/models/LogInUser";
import i18n from "@/i18n";
import authService from "@/services/planning/AuthService";
import { mapActions } from "vuex";

export default {
  name: "LoginWdg2",

  data: () => ({
    valid: true,
    logInUser: new LogInUser(null, null),
    defaultItem: new LogInUser(null, null),
    emptyField: [(v) => !!v || i18n.t("errorFrontEnd.requiredField")],
  }),
  methods: {
    ...mapActions("notificationModule", ["showNotification"]),

    close() {
      this.$nextTick(() => {
        this.logInUser = Object.assign({}, this.defaultItem);
      });
      this.$refs.form.reset();
      this.$emit("wdg2Close", false);
    },
    loginWdg2() {
      if (this.$refs.form.validate()) {
        let testRequest = authService
          .testDg2LogIn(this.logInUser)
          .then((res) => {
            if ((res.data = true)) {
              $cookies.set("dg2User", {
                email: this.logInUser.email,
                password: this.logInUser.password,
              });
              this.showNotification({
                messageAlert: "Valid credentials",
                typeAlert: "success",
              });
              this.$emit("logInUser", this.logInUser);
            }
          })
          .catch((reason) => {
            this.showNotification({
              messageAlert: "Invalid credentials",
              typeAlert: "error",
            });
          });
      }
    },
  },
};
</script>

<style lang="scss">
#wdg2 {
  padding: 2rem;
}
</style>
